import React from "react";
import Navbar from "../../components/navbar/Navbar";

const Pages404 = () => {
  return (
    <main>
      <Navbar />
      <section className="flex justify-center pt-20 md:pt-28">
        This page is not available for you.
      </section>
    </main>
  );
};

export default Pages404;
